'use client';

import { Button } from '@/components/ui/button';
import useGeneratorStore, { EditorInstrumentEnum } from '@/state/generator-store';
import { cn } from '@/utils';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import { Music } from 'lucide-react';
import { useState } from 'react';
import CardContainer from '../../ui/CardContainer';
import Divider from '@/components/Divider';

const instruments = [
  {
    name: 'GUITARS',
    items: [
      {
        name: 'Acoustic Guitar',
        id: EditorInstrumentEnum.AcousticGuitar,
      },
      {
        name: 'Electric Guitar',
        id: EditorInstrumentEnum.ElectricGuitar,
      },
      // {
      //   name: 'Flamenco Guitar',
      //   id: EditorInstrumentEnum.FlamencoGuitar,
      // },
      // {
      //   name: 'Steel Guitar',
      //   id: EditorInstrumentEnum.SteelGuitar,
      // },
      {
        name: 'Grand Piano',
        id: EditorInstrumentEnum.GrandPiano,
      },
    ],
  },
  {
    name: 'PIANO & KEYBOARDS',
    items: [
      {
        name: 'Grand Piano',
        id: EditorInstrumentEnum.GrandPiano,
      },
      {
        name: 'Electric Piano',
        id: EditorInstrumentEnum.ElectricPiano,
      },
    ],
  },
  {
    name: 'STRINGS',
    items: [
      {
        name: 'Violin',
        id: EditorInstrumentEnum.Violin,
      },
      {
        name: 'Harp',
        id: EditorInstrumentEnum.Harp,
      },
    ],
  },
  {
    name: 'Brass & Wind',
    items: [
      {
        name: 'Bass',
        id: EditorInstrumentEnum.Bass,
      },
      {
        name: 'Trumpet',
        id: EditorInstrumentEnum.Trumpet,
      },
      {
        name: 'Trombone',
        id: EditorInstrumentEnum.Trombone,
      },
    ],
  },
];

export const BUTTON_STYLES = {
  base: `
    flex justify-start align-top bg-gradient-to-br from-[#383a3c] to-[#2b2e2f] rounded border border-[#46494c] opacity-80
    hover:opacity-100 h-[104px] w-[104px] transition-opacity duration-200
  `,
  active: 'from-[#ff5b27] to-[#c24017] bg-gradient-to-r ring-1 ring-zinc-400',
  inactive: 'button-shadow',
} as const;

interface indexProps {
  hide: () => void;
}

const index: React.FC<indexProps> = ({ hide }) => {
  const [selectedCategory, setSelectedCategory] = useState(instruments[0]);

  const { setEditorSelectedInstrument } = useGeneratorStore();

  return (
    <div className="w-[max-content] bg-gradient-to-br from-[#383a3c] to-[#2b2e2f] p-4 flex items-center justify-center rounded-2xl">
      {/* <div className="p-2 bg-[#191A1B] rounded-xl">
        <div className="grid grid-cols-2 grid-rows-2 gap-2 bg-[#191A1B]">
          {instruments.map((instrumentClass) => (
            <Button
              variant="ghost"
              type="button"
              key={instrumentClass.name}
              onClick={() => setSelectedCategory(instrumentClass)}
              className={cn(
                BUTTON_STYLES.base,
                selectedCategory.name === instrumentClass.name ? BUTTON_STYLES.active : BUTTON_STYLES.inactive,
              )}
              style={{
                padding: '0',
              }}
            >
              <div className="flex flex-col w-full h-full p-2 justify-between">
                <div className="w-full flex items-center">
                  <Music className="w-5 h-5" />
                </div>
                <div className="text-[0.8rem] font-normal uppercase leading-tight w-full break-words text-wrap max-w-[90px] text-left">
                  {instrumentClass.name}
                </div>
              </div>
            </Button>
          ))}
        </div>
      </div>
      <Divider /> */}
      <div className="relative w-[232px] bg-[#191A1B] rounded-xl">
        <ScrollArea.Root className="h-[232px] overflow-hidden rounded-xl">
          <ScrollArea.Viewport className="h-full w-full my-2">
            <div className="space-y-px py-1 px-3">
              {selectedCategory.items.map((instrument) => (
                <button
                  key={instrument.id}
                  className="w-full text-left text-zinc-50 p-2 hover:bg-zinc-800 focus:outline-none focus:bg-zinc-800 transition-colors text-sm border-b border-dashed border-white/50 rounded-md"
                  onClick={() => {
                    setEditorSelectedInstrument(instrument.id);
                    hide();
                  }}
                >
                  {instrument.name}
                </button>
              ))}
            </div>
          </ScrollArea.Viewport>
          <ScrollArea.Scrollbar
            className="flex select-none touch-none p-0.5 bg-transparent transition-colors duration-150 ease-out data-[orientation=vertical]:w-2 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
            orientation="vertical"
          >
            <ScrollArea.Thumb className="flex-1 bg-zinc-600 rounded-full relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
        <div className="absolute top-0 left-0 w-full border-t border-zinc-700" />
      </div>
    </div>
  );
};

export default index;
